import { Fragment } from 'react';

import { useDidMount } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

import { useBlockStepManagerContext } from './blockStepManager.context';
import { BlockStep, BlockStepManagerState, BlockStepManagerStateBlock } from './blockStepManager.types';

export interface BlockStepManagerComponentProps {
	blocks: BlockStep[];
	defaultBlocksState?: BlockStepManagerStateBlock[];
}

export const BlockStepManagerComponent = (props: BlockStepManagerComponentProps) => {
	const { blocks, setState } = useBlockStepManagerContext();

	useDidMount(() => {
		!blocks && setState(getInitialState(props.blocks, props.defaultBlocksState));
	});

	return (
		<>
			{blocks?.map((block, index) => {
				const { isOpen, name } = block;
				const { render } = props.blocks.find((b) => b.name === name) || {};

				return <Fragment key={`${name}${index}`}>{render?.({ isOpen })}</Fragment>;
			})}
		</>
	);
};

const getInitialState = (
	blocksStep: BlockStep[],
	defaultBlocksState?: BlockStepManagerStateBlock[]
): BlockStepManagerState => {
	if (!blocksStep.length) {
		return {};
	}

	const blocks: BlockStepManagerStateBlock[] = defaultBlocksState?.length
		? defaultBlocksState.map((block) => ({ name: block.name, isOpen: block.isOpen }))
		: [
				{
					isOpen: true,
					name: blocksStep[0].name,
				},
		  ];

	return { blocks };
};
